import { MatTableDataSource, MatPaginator, MatFormFieldModule } from '@angular/material';
import { ConfiguracionesService } from '../../../../shared/configuraciones.service';
import { Component, ViewChild, OnInit, ViewEncapsulation, ElementRef, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import {MatDialog,MatDialogRef,MAT_DIALOG_DATA} from '@angular/material/dialog'
import { Router } from '@angular/router';
import { DialogAgregarTransportadores } from '../dialogAgregarTransportadores/dialogAgregarTransportadores.component';
import { dialogAgregarPropietarioVehiculo } from '../dialogAgregarPropietarioVehiculo/dialogAgregarPropietarioVehiculo.component';

export interface DialogData {
  idTipoDoc: string;
  tipo: string;
  descripcion: string;
  tipoanterior: string;
  descripcionanterior: string;
}
@Component({
  selector: 'app-FragmentTransportador',
  templateUrl: './FragmentTransportador.component.html',
  styleUrls: ['./FragmentTransportador.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class FragmentTransportador implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public codigo;
  public iscargado = true;
  public ismenu = false;
  bancovalue: string;
  constructor(private route: Router,private configuracionesService: ConfiguracionesService, public toastr: ToastrManager,public dialogEliminar: MatDialog,public dialog: MatDialog,public dialogagregar: MatDialog) {

  
  }

   idTipoDoc: string;
   tipo: string;
   descripcion: string;
   tipoanterior: string;
   descripcionanterior: string;

   displayedColumns: string[] = ['idTransportador', 'nombrePropietario','placa','editar','eliminar'];
   dataSource = new MatTableDataSource();

 
  ngOnInit(): void {

    this.descargarConfiguraciones()
    this.descargarConTipoDoc()  
  
  }

  
  ngAfterViewInit() {

    this.dataSource.paginator = this.paginator;

  }


  descargarConfiguraciones() {

    this.configuracionesService.descargarTransportes().subscribe(configuraciones => {
  
      this.dataSource.data = configuraciones;

      setTimeout(() => {
        this.iscargado = false;
        this.ismenu = true;
       }, 200);

    
  
    
    });
  }

  descargarConTipoDoc() {

    this.configuracionesService.getConTipoDoc ().subscribe(tipoDocus => {

      for (let tipo of tipoDocus) {

           this.codigo=tipo.contipodoc
      
      
      }  

    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  editar(tipo: any) {

    localStorage.setItem("idTransportador", tipo.idTransportador );

    this.route.navigate(['/Transporte']);
   

  }

  nuevoBanco():void {

    this.dialogagregar.open(dialogAgregarPropietarioVehiculo, {
      width: '850px',
      maxHeight:'700px',
      data: {id: this.codigo},
    
      });
  
    }

  deletebanco(tipo: any) {

  }

  
  auditoria():void {

    this.route.navigate(['/AuditoriaTipoDoc']);
    
  }
  
}
